<template>
  <div
    class="dragging-element" 
    @mousedown="e => startDrag(e)"
    @click="e => selectElementDragResize(e, detailsObject, bound)"
  >
    <div class="resizeHandles">
      <div class="resizeLeft" @mousedown="e => startResize(e, 'left')"></div>
      <div class="resizeRight" @mousedown="e => startResize(e, 'right')"></div>
      <div class="resizeTop" @mousedown="e => startResize(e, 'top')"></div>
      <div class="resizeBot" @mousedown="e => startResize(e, 'bottom')"></div>
      <div class="resizeTopLeft" @mousedown="e => startResize(e, 'topLeft')"></div>
      <div class="resizeBotLeft" @mousedown="e => startResize(e, 'bottomLeft')"></div>
      <div class="resizeTopRight" @mousedown="e => startResize(e, 'topRight')"></div>
      <div class="resizeBotRight" @mousedown="e => startResize(e, 'bottomRight')"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      detailsObject: {
        type: Object,
        required: false
      },
      bound: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        selectedObjectMoveResize: {
          element: null,
          offset: null,
          detailsObject: null,
          parent: null,
          bound: false,
          handleLocation: null,
        }
      }
    },
    methods: {
      selectElementDragResize(event, detailsObject, bound) {
        event.stopPropagation();
        this.$emit('selectObjectMoveResize', event, detailsObject);
        if (this.selectElementDragResize.element == null) {
          if (detailsObject != null) {
            this.selectedObjectMoveResize.detailsObject = detailsObject;
          }
          this.selectedObjectMoveResize.element = event.currentTarget;
          this.selectedObjectMoveResize.parent = event.currentTarget.parentElement;
          this.selectedObjectMoveResize.bound = bound;

          let selected = event.currentTarget;
          let handles = selected.querySelector('.resizeHandles');
          this.selectedObjectMoveResize.element = selected;
          handles.classList.add('activeHandles'); 
          selected.classList.add('selected-drag-resize');

          let dimensions = selected.getBoundingClientRect();
          selected.style.width = dimensions.width + 'px';
          selected.style.height = dimensions.height + 'px';
          selected.style.position = 'absolute';

          document.addEventListener('mousedown', this.deselectObjectMoveResize);
        }
      },
      startResize(event, handleLocation) {
        event.stopPropagation();
        if (!this.selectedObjectMoveResize.element) {
          return;
        }
        this.selectedObjectMoveResize.handleLocation = handleLocation;
        let elementDimensions = this.selectedObjectMoveResize.element.getBoundingClientRect();
        this.selectedObjectMoveResize.offset = {
          left: event.clientX - elementDimensions.x,
          top: event.clientY - elementDimensions.y
        };

        document.addEventListener('mousemove', this.onResize);
        document.addEventListener('mouseup', this.stopResize);
      },
      onResize(event) {
        event.stopPropagation();
        let shortenObjectName = this.selectedObjectMoveResize;
        let screen = shortenObjectName.parent.getBoundingClientRect();

        let calculateLeftHandleWidth = parseInt(shortenObjectName.element.style.width) - event.movementX;
        let calculateRightHandleWidth = parseInt(shortenObjectName.element.style.width) + event.movementX;
        let calculateBottomHandleHeight = parseInt(shortenObjectName.element.style.height) + event.movementY;
        let calculateTopHandleHeight = parseInt(shortenObjectName.element.style.height) - event.movementY;
        let calculateTopHandleTop = parseInt(shortenObjectName.element.style.top) + event.movementY;
        let calculateLeftHandleLeft = parseInt(shortenObjectName.element.style.left) + event.movementX;
        
        if (shortenObjectName.bound) {
          if (calculateLeftHandleLeft <= 0) {
            calculateLeftHandleLeft = 0;
            calculateLeftHandleWidth = parseInt(shortenObjectName.element.style.width);
          }
          if (calculateTopHandleTop <= 0) {
            calculateTopHandleTop = 0;
            calculateTopHandleHeight = parseInt(shortenObjectName.element.style.height);
          }
          if ((calculateRightHandleWidth + parseInt(shortenObjectName.element.style.left)) >= screen.width) {
            calculateRightHandleWidth = screen.width - shortenObjectName.element.style.left;
          }
          if ((calculateBottomHandleHeight + parseInt(shortenObjectName.element.style.top)) >= screen.height) {
            calculateBottomHandleHeight = screen.height - parseInt(shortenObjectName.element.style.top);
          }
        }
        
        switch (shortenObjectName.handleLocation) {
          case 'left':
            shortenObjectName.element.style.width = `${calculateLeftHandleWidth}px`;
            shortenObjectName.element.style.left = `${calculateLeftHandleLeft}px`;
            break;
          case 'right':
            shortenObjectName.element.style.width = `${calculateRightHandleWidth}px`;
            break;
          case 'top':
            shortenObjectName.element.style.height = `${calculateTopHandleHeight}px`;
            shortenObjectName.element.style.top = `${calculateTopHandleTop}px`;
            break;
          case 'bottom':
            shortenObjectName.element.style.height = `${calculateBottomHandleHeight}px`;
            break;
          case 'topLeft':
            shortenObjectName.element.style.width = `${calculateLeftHandleWidth}px`;
            shortenObjectName.element.style.height = `${calculateTopHandleHeight}px`;
            shortenObjectName.element.style.left = `${calculateLeftHandleLeft}px`;
            shortenObjectName.element.style.top = `${calculateTopHandleTop}px`;
            break;
          case 'topRight':
            shortenObjectName.element.style.width = `${calculateRightHandleWidth}px`;
            shortenObjectName.element.style.height = `${calculateTopHandleHeight}px`;
            shortenObjectName.element.style.top = `${calculateTopHandleTop}px`;
            break;
          case 'bottomLeft':
            shortenObjectName.element.style.width = `${calculateLeftHandleWidth}px`;
            shortenObjectName.element.style.height = `${calculateBottomHandleHeight}px`;
            shortenObjectName.element.style.left = `${calculateLeftHandleLeft}px`;
            break;
          case 'bottomRight':
            shortenObjectName.element.style.width = `${calculateRightHandleWidth}px`;
            shortenObjectName.element.style.height = `${calculateBottomHandleHeight}px`;
            break;
        }
      },
      stopResize(event) {
        event.stopPropagation();
        if (this.selectedObjectMoveResize.detailsObject != null) {
          this.selectedObjectMoveResize.detailsObject.width = parseInt(this.selectedObjectMoveResize.element.style.width);
          this.selectedObjectMoveResize.detailsObject.height = parseInt(this.selectedObjectMoveResize.element.style.height);
          this.selectedObjectMoveResize.detailsObject.top = this.selectedObjectMoveResize.element.style.top;
          this.selectedObjectMoveResize.detailsObject.left = this.selectedObjectMoveResize.element.style.left;
        }

        document.removeEventListener('mousemove', this.onResize);
        document.removeEventListener('mouseup', this.stopResize);
      },
      startDrag(event) {
        event.stopPropagation();
        if (!this.selectedObjectMoveResize.element) {
          return;
        }
        let elementDimensions = this.selectedObjectMoveResize.element.getBoundingClientRect();
        this.selectedObjectMoveResize.offset = {
          left: event.clientX - elementDimensions.x,
          top: event.clientY - elementDimensions.y
        };

        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('mouseup', this.stopDrag);
      },
      onDrag(event) {
        event.stopPropagation();
        let elementDimensions = this.selectedObjectMoveResize.element.getBoundingClientRect();
        let screen = this.selectedObjectMoveResize.parent.getBoundingClientRect();
        let mousePosition = {
            left: event.clientX - screen.x,
            top: event.clientY - screen.y
        };
        if (this.selectedObjectMoveResize.bound) {
          let calculateXMove = mousePosition.left - this.selectedObjectMoveResize.offset.left;
          let calculateYMove = mousePosition.top - this.selectedObjectMoveResize.offset.top;
          if (!(calculateXMove < 0 || (calculateXMove + elementDimensions.width) > screen.width)) {
            this.selectedObjectMoveResize.element.style.left = `${calculateXMove}px`;
          } else if (calculateXMove < 0) {
            this.selectedObjectMoveResize.element.style.left = 0;
          } else {
            this.selectedObjectMoveResize.element.style.left = screen.width - elementDimensions.width;
          }
          if (!(calculateYMove < 0 || (calculateYMove + elementDimensions.height) > screen.height)) {
            this.selectedObjectMoveResize.element.style.top = `${calculateYMove}px`;
          } else if (calculateYMove < 0) {
            this.selectedObjectMoveResize.element.style.top = 0;
          } else {
            this.selectedObjectMoveResize.element.style.top = screen.height - elementDimensions.height;
          }
        } else {
          let calculateXMove = mousePosition.left - this.selectedObjectMoveResize.offset.left;
          let calculateYMove = mousePosition.top - this.selectedObjectMoveResize.offset.top;
          this.selectedObjectMoveResize.element.style.left = `${calculateXMove}px`;
          this.selectedObjectMoveResize.element.style.top = `${calculateYMove}px`;
        }
      },
      stopDrag(event) {
        event.stopPropagation();
        if (this.selectedObjectMoveResize.detailsObject != null) {
          let elementDimensions = this.selectedObjectMoveResize.element.getBoundingClientRect();
          let screen = this.selectedObjectMoveResize.parent.getBoundingClientRect();
          this.selectedObjectMoveResize.detailsObject.x = elementDimensions.x - screen.x;
          this.selectedObjectMoveResize.detailsObject.y = elementDimensions.y - screen.y;
        }
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
      },
      deselectObjectMoveResize(event) {
        let obj = this.selectedObjectMoveResize;
        let selected = obj.element;
        let handles = selected.querySelector('.resizeHandles');

        if (selected.contains(event.target)) {
          return;
        }

        handles.classList.remove('activeHandles'); 
        selected.classList.remove('selected-drag-resize');

        Object.keys(obj).forEach(key => {
          obj[key] = null;
        });

        this.$emit('deselectObjectMoveResize');
        document.removeEventListener('mousedown', this.deselectObjectMoveResize);
      },
    },
    beforeDestroy() {
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      document.removeEventListener('mousemove', this.onResize);
      document.removeEventListener('mouseup', this.stopResize);
    }
  }
</script>

<style lang="scss" scoped>
  .dragging-element {
    position: absolute;
    top: 0;
    left: 0;
    user-select: none;
    cursor: pointer;
  }

  .dragging-element.selected-drag-resize {
    border: solid black 2px;
    cursor: move;
  }

  .resizeHandles {
    $standardDeviation: 5px;
    display: none;
    z-index: 40;

    &.activeHandles {
      display: block;
    }

    .resizeLeft, .resizeRight, .resizeTop, .resizeBot, .resizeTopLeft, .resizeBotLeft, .resizeTopRight, .resizeBotRight {
      position: absolute;
      background-color: transparent;
    }

    .resizeLeft {
      left: -#{$standardDeviation};
      top: #{$standardDeviation};
      height: calc(100% - #{$standardDeviation} * 2);
      width: #{$standardDeviation * 2};
      cursor: ew-resize;
    }

    .resizeRight {
      right: -#{$standardDeviation};
      top: #{$standardDeviation};
      height: calc(100% - #{$standardDeviation} * 2);
      width: #{$standardDeviation * 2};
      cursor: ew-resize;
    }

    .resizeTop {
      left: #{$standardDeviation};
      top: -#{$standardDeviation};
      height: #{$standardDeviation * 2};
      width: calc(100% - #{$standardDeviation} * 2);
      cursor: ns-resize;
    }

    .resizeBot {
      left: #{$standardDeviation};
      bottom: -#{$standardDeviation};
      height: #{$standardDeviation * 2};
      width: calc(100% - #{$standardDeviation} * 2);
      cursor: ns-resize;
    }

    .resizeTopLeft {
      left: -#{$standardDeviation};
      top: -#{$standardDeviation};
      height: #{$standardDeviation * 2};
      width: #{$standardDeviation * 2};
      cursor: nwse-resize;
    }

    .resizeBotLeft {
      left: -#{$standardDeviation};
      bottom: -#{$standardDeviation};
      height: #{$standardDeviation * 2};
      width: #{$standardDeviation * 2};
      cursor: nesw-resize;
    }

    .resizeTopRight {
      right: -#{$standardDeviation};
      top: -#{$standardDeviation};
      height: #{$standardDeviation * 2};
      width: #{$standardDeviation * 2};
      cursor: nesw-resize;
    }

    .resizeBotRight {
      right: -#{$standardDeviation};
      bottom: -#{$standardDeviation};
      height: #{$standardDeviation * 2};
      width: #{$standardDeviation * 2};
      cursor: nwse-resize;
    }
  }
</style>